import { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from '../contexts/ThemeContext';
import { LanguageContext } from '../contexts/LanguageContext';
import { FormattedMessage } from 'react-intl';
import { useParams, useLocation } from "react-router-dom";
import messages from '../lang/preferences';
import Axios from 'axios';
import url from '../constants/urlsPaths';

import './Login.css';

export default function ApiLogin({ setToken, context=null }) {
    const [key, setKey] = useState(false);
    const [displayErrorEmail, setDisplayErrorEmail] = useState(false);
    const [displayErrorPassowrd, setDisplayErrorPassword] = useState(false);
    const [displaySuccess, setDisplaySuccess] = useState(false);
    const { themeValue } = useContext(ThemeContext);
    const { selectLanguage } = useContext(LanguageContext);
    const location = useLocation();
    const { keyParam } = useParams();
    const [pinSent, setPinSent] = useState(false);
    const [pin, setPin] = useState('');

    useEffect(() => {  
        if (keyParam) {
            Axios.post(url.keyCheck, { key: keyParam })
                .then((response) => {
                    if (response.data.auth === false) {
                        console.log("ErrorType", response.data?.errType ? response.data.errType : "Unknown error");
                    } else {
                        setKey(keyParam);
                        console.log('🔑 Key auto-populated from URL param:', keyParam);
                    }
                });
        }
    }, [location.search, keyParam]);

    const displayErrorMessage = (data) => {
        switch (data.errType) {
            case 1:
                setDisplayErrorEmail(true);
                setTimeout(function () { setDisplayErrorEmail(false) }, 5000);
                break;
            case 2:
                setDisplayErrorPassword(true);
                setTimeout(function () { setDisplayErrorPassword(false) }, 5000);
                break;
            default:
                console.log("Error")
                break;
        }
    }
    const displaySuccessMessage = (data) => {
        setDisplaySuccess(true);
        setTimeout(function () {
            setDisplaySuccess(false);
            selectLanguage(data.language)
            setToken(data);
        }, 1000);
    }

    const sendPin = (e) => {
        e.preventDefault();
        console.log("Sending PIN to user");

        Axios.post(url.sendPin, {
            key: key
        }).then((response) => {
            if (response.data.auth === false) {
                displayErrorMessage(response.data)
            }
            else {
                setPinSent(true);
                displaySuccessMessage(response.data);
            }
        })
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        Axios.post(url.optCheck, {
            pin: pin,
            key: key,
        }).then((response) => {
            if (response.data.auth === false) {
                console.log("ErrorType", response.data?.errType ? response.data.errType : "Unknown error");
                
                displayErrorMessage(response.data)
            }
            else {
                displaySuccessMessage(response.data);
            }
        })
    }
    return (
        <div>
            <div id="Login" className={themeValue === "day" ? "" : "nightDiv"}>
                <div id="Login-content-api">
                    {
                        context === "login" ? <div>
                            <br></br>
                            { !key &&
                                <div>
                                    <h2 className="generic-titles"><FormattedMessage {...messages.GENERIC_INTRO_TITLE} /></h2>
                                    <h3 className="generic-titles"><FormattedMessage {...messages.GENERIC_INTRO_SUBTITLE} /></h3>
                                    <p className="intro-text">
                                        <FormattedMessage {...messages.GENERIC_INTRO_1} /><br /><br />
                                        <FormattedMessage {...messages.GENERIC_INTRO_2} /><br /><br />
                                        <FormattedMessage {...messages.GENERIC_INTRO_3} /><br /><br />
                                        <FormattedMessage {...messages.GENERIC_INTRO_4} /><br /><br />
                                        <FormattedMessage {...messages.GENERIC_INTRO_5} />
                                    </p>
                                </div>
                            }
                            { /* key && <div><p className="intro-text"><FormattedMessage {...messages.LOGIN_TEXT} /></p><br></br><br></br></div> */}
                            
                            { key && <h2 style={{ textAlign: "center", marginBottom: "20px" }}><FormattedMessage {...messages.CONFIRM_USER} /></h2>}</div> : context === "results" ? <div><span className="login-subtitle"><br></br><h2>Results Portal</h2><br></br></span></div> : <div><span className="login-subtitle"><br></br><h2>Manager Portal</h2><br></br></span></div>
                    }
                    { pinSent && key &&
                        <form id="Login-form" onSubmit={handleSubmit}>
                            <div className="confirm-user-text-box">
                                <p><FormattedMessage {...messages.CHECK_PIN_RECEIVED_DESC} /></p>
                            </div>
                            <label>
                                <p><FormattedMessage {...messages.PIN_LABEL} /></p>
                                <input 
                                    type="text" 
                                    value={pin}
                                    onChange={e => setPin(e.target.value)} 
                                    autoComplete="one-time-code"
                                    inputMode="numeric"
                                    required 
                                />
                            </label>
                            <div>
                                <button type="submit"><FormattedMessage {...messages.START_SCOPE} /></button>
                            </div>
                        </form>
                    }
                    { !pinSent && key &&
                        <form id="send-pin-form" onSubmit={sendPin}>
                            <div className="confirm-user-text-box">
                                <p><FormattedMessage {...messages.SEND_PIN_TO_CONFIRM_USER_DESC} /></p>
                            </div>
                            <div>
                                <button type="submit"><FormattedMessage {...messages.SEND_PIN} /></button>
                            </div>
                        </form>
                    }
                    <div className="Login-toasts">
                        {
                            displayErrorEmail ? <span className="Login-toast-fail"><FormattedMessage {...messages.MSG_WRONG_EMAIL} /></span> : null
                        }
                        {
                            displayErrorPassowrd ? <span className="Login-toast-fail"><FormattedMessage {...messages.MSG_WRONG_PASS} /></span> : null
                        }
                        {
                            displaySuccess ? <span className="Login-toast-success" style={{ color: "rgb(113, 219, 122)" }}><FormattedMessage {...messages.MSG_SUCCESS} /></span> : null
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

ApiLogin.propTypes = {
    setToken: PropTypes.func.isRequired
}
